<div class="channel-table-row text" style="background-color: transparent">
    <div data-cy="channel-group-channel-number-label" class="col-ch-no">
        {{ "labels.channel.number" | translate }}
    </div>
    <div data-cy="channel-group-channel-name-label" class="col-ch-name">
        {{ "labels.channel.name" | translate }}
    </div>
    <div data-cy="channel-group-channel-value-label" class="col-value">
        {{ "labels.channel.value" | translate }}
    </div>
    <div data-cy="channel-group-channel-status-label" class="col-status">
        {{ "labels.channel.status" | translate }}
    </div>
    <div data-cy="channel-group-channel-condition-input-range-label" class="col-range">
        {{ "labels.channel.condition-input-range" | translate }}
    </div>
</div>
